import { CURRENCIES, ISO_CURRENCIES } from './iso4217.js';
export { CURRENCIES } from './iso4217.js';

type CurrencyCode = (typeof CURRENCIES)[number];
const codes = new Set<string>(CURRENCIES);
export const isCurrency = (value: string): value is CurrencyCode => codes.has(value);

/** Fixed register for validation; Intl supplies locale-aware names and symbols. */
const legacySymbols: Partial<Record<CurrencyCode, string>> = { ILS: '₪', USD: '$', EUR: '€', GBP: '£', JPY: '¥' };
export const CURRENCY_SYMBOLS = Object.fromEntries(CURRENCIES.map(code => [code, legacySymbols[code] ?? code])) as Record<CurrencyCode, string>;
const precision = new Map<CurrencyCode, number>();
export function currencyDigits(currency: CurrencyCode): number {
  let digits = precision.get(currency);
  if (digits === undefined) {
    digits = ISO_CURRENCIES[currency].digits ?? new Intl.NumberFormat('en', {style:'currency',currency}).resolvedOptions().maximumFractionDigits ?? 2;
    precision.set(currency, digits);
  }
  return digits;
}
export function roundCurrency(amount: number, currency: CurrencyCode): number {
  const scale = 10 ** currencyDigits(currency);
  return Math.round((amount + Number.EPSILON) * scale) / scale;
}
export function currencyStep(currency: string): string {
  return String(1 / 10 ** currencyDigits(isCurrency(currency) ? currency : 'ILS'));
}
const names = new Map<string, Intl.DisplayNames>();
export function currencyName(currency: CurrencyCode, locale = 'he'): string {
  try {
    let display = names.get(locale);
    if (!display) {display = new Intl.DisplayNames([locale], {type:'currency'}); names.set(locale,display);}
    const name = display.of(currency);
    return name && name !== currency ? name : ISO_CURRENCIES[currency].name;
  } catch {return ISO_CURRENCIES[currency].name;}
}
